export const recentActivityAPI = async()=> {
    const parameters  = {
        length: 5
    }
    const response = await fetch(
        `${process.env.REACT_APP_BACKEND_MACHINE}/api/fetch-latest-updated-content`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(parameters),
        }
    );

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error on fetching the latest updated content: ${errorData.message}`);
    }

    const data = await response.json();
    return data;
}

export const frequentlyUsedAPI = async()=> {
    const parameters  = {
        days: 14,
        length: 5
    }
    const response = await fetch(
        `${process.env.REACT_APP_BACKEND_MACHINE}/api/fetch-frequently-used-activity`,
        {
            method: 'POST',

            headers: {
                'Authorization': `Bearer ${ localStorage.getItem ( 'token' ) }`,
            },
            body: JSON.stringify ( parameters ),
        }
    )
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error on fetching the frequently used documents: ${errorData.message}`);
    }
    const data = await response.json();
    return data;
}

